import React, {Component} from 'react';
import Breadcrumb from "../components/breadcrumb";
// import NewProduct from "../common/new-product";
// import Filter from "../components/collection-settings/filter";
// import FilterBar from "./common/filter-bar";
import ProductListing from "../components/collection-settings/product-listing";
// import StickyBox from "react-sticky-box";
import { graphql } from 'gatsby';
import Img from 'gatsby-image'
import SEO from '../components/seo';
import Layout from '../layouts';

class Collection extends Component {

    state = {
        layoutColumns:3
    }

    openFilter = () => {
        document.querySelector(".collection-filter").style = "left: -15px";
    }
    
    render (){
        const collection = this.props.data.shopifyCollection

        return (
            <Layout>
                <SEO title={collection.title}/>
                <Breadcrumb title={'Collection'}/>

                <section className="section-b-space">
                    <div className="collection-wrapper">
                        <div className="container">
                            <div className="row">
                                {/* <div className="col-sm-3 collection-filter">
                                    <StickyBox offsetTop={20} offsetBottom={20}>
                                        <div>
                                            <Filter/>
                                            <NewProduct/>
                                            <div className="collection-sidebar-banner">
                                                <a href="#">
                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/side-banner.png`}  alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </StickyBox>
                                </div> */}
                                <div className="collection-content col">
                                    <div className="page-main-content ">
                                        <div className="">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="top-banner-wrapper">
                                                        {collection.image !== null && (
                                                            <Img fluid={collection.image.localFile.childImageSharp.fluid} className="img-fluid" />
                                                        )}
                                                        <div className="top-banner-content small-section">
                                                            <h2>{collection.title}</h2>
                                                            {collection.descriptionHtml && (
                                                                <p dangerouslySetInnerHTML={{__html: collection.descriptionHtml}}></p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="collection-product-wrapper">
                                                        {/* <div className="product-top-filter">
                                                            <div className="container-fluid p-0">
                                                                <div className="row">
                                                                    <div className="col-xl-12">
                                                                        <div className="filter-main-btn">
                                                                            <span onClick={this.openFilter}
                                                                                className="filter-btn btn btn-theme"><i
                                                                                className="fa fa-filter"
                                                                                aria-hidden="true"></i> Filter</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <FilterBar onLayoutViewClicked={(colmuns) => this.LayoutViewClicked(colmuns)}/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}

                                                        {/*Products Listing Component*/}
                                                        <ProductListing colSize={this.state.layoutColumns} products={collection.products}/>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </Layout>
        )
    }
}

export const query = graphql `
    query CollectionPage($handle: String) {
        shopifyCollection(handle: {eq: $handle}) {
            handle
            title
            descriptionHtml
            image {
                localFile {
                    childImageSharp {
                        fluid (maxWidth: 1370, maxHeight: 385) {
                            ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            products {
                shopifyId
                handle
                title
                description
                variants {
                    shopifyId
                    title
                    availableForSale
                    priceV2 {
                            amount
                            currencyCode
                        }
                    compareAtPriceV2 {
                            amount
                            currencyCode
                        }
                    selectedOptions {
                            name
                            value
                        }
                    image {
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 600, maxHeight: 600){
                                    ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                    }
            }
        }
    }  
`

export default Collection